<template>
  <Head title="Kunjungan" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Kunjungan', href: route('kunjungan.index') },
          ]"
        />

        <!-- Stat Cards -->
        <div class="grid grid-cols-2 gap-4 mb-6 sm:grid-cols-3 lg:grid-cols-5">
          <div
            v-for="card in statCards"
            :key="card.label"
            class="p-4 bg-white border border-gray-200 shadow rounded-xl"
          >
            <p class="text-sm text-gray-500">{{ card.label }}</p>
            <p class="mt-1 text-2xl font-bold text-gray-900">
              {{ card.value.toLocaleString("id-ID") }}
            </p>
          </div>
        </div>

        <!-- Table -->
        <div class="mb-4 sm:mb-6">
          <h3 class="text-lg font-semibold text-gray-900">
            Riwayat Kunjungan
          </h3>
          <p class="mt-1 text-sm text-gray-600">
            Daftar kunjungan terbaru ke halaman publik website
          </p>
        </div>

        <div
          class="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
        >
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    Waktu
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    IP Address
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Method
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    Halaman
                  </th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    User Agent
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr
                  v-for="visit in visits.data"
                  :key="visit.id"
                  class="transition-colors duration-150 hover:bg-gray-50"
                >
                  <td
                    class="py-4 pl-4 pr-3 text-sm text-gray-500 whitespace-nowrap sm:pl-6"
                  >
                    {{ formatDate(visit.created_at) }}
                  </td>
                  <td class="px-3 py-4 text-sm text-gray-900 whitespace-nowrap">
                    {{ visit.ip_address }}
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap">
                    <span
                      class="inline-flex px-2 py-0.5 text-xs font-medium text-indigo-700 bg-indigo-100 rounded-full"
                    >
                      {{ visit.method }}
                    </span>
                  </td>
                  <td
                    class="max-w-xs px-3 py-4 text-sm text-gray-900 truncate"
                    :title="visit.url"
                  >
                    {{ visit.route }}
                  </td>
                  <td
                    class="max-w-xs px-3 py-4 text-sm text-gray-500 truncate"
                    :title="visit.user_agent"
                  >
                    {{ visit.user_agent || "-" }}
                  </td>
                </tr>
                <tr v-if="!visits.data.length">
                  <td
                    colspan="5"
                    class="px-3 py-8 text-sm text-center text-gray-500"
                  >
                    Belum ada data kunjungan.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <Pagination :data="visits" :updatedPageNumber="updatedPageNumber" />
      </div>
    </template>
  </Container>
</template>

<script setup>
import { Head, router } from "@inertiajs/vue3";
import { computed } from "vue";

import Pagination from "@/Components/Pagination.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Header from "@/Components/Header.vue";
import Container from "@/Layouts/Container.vue";

const props = defineProps({
  visits: {
    type: Object,
    required: true,
  },
  stats: {
    type: Object,
    required: true,
  },
});

const statCards = computed(() => [
  { label: "Hari Ini", value: props.stats.today },
  { label: "7 Hari Terakhir", value: props.stats.lastWeek },
  { label: "30 Hari Terakhir", value: props.stats.lastMonth },
  { label: "Tahun Ini", value: props.stats.lastYear },
  { label: "Total", value: props.stats.total },
]);

const formatDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleString("id-ID", {
    dateStyle: "medium",
    timeStyle: "short",
  });
};

const updatedPageNumber = (link) => {
  if (link && link.url) {
    router.get(
      link.url,
      {},
      { preserveState: true, preserveScroll: true, replace: true }
    );
  }
};
</script>
